import BeautyPreferencesTooltip from 'components/ProductPage/RatingsAndReviews/ReviewsFilters/BeautyPreferencesTooltip/BeautyPreferencesTooltip';

export default BeautyPreferencesTooltip;
